var filterElem = document.getElementById("filter");
var cachedCount = null;
var originalTitle = null;

if (filterElem !== null) {
    // capture phase start before frontend.js
    filterElem.addEventListener("category.updated", function (e) {
        var headElem = document.getElementsByTagName('h1')[0];
        var countElem = headElem.querySelector('.is-count');
        
        // save count
        cachedCount = countElem ? countElem.textContent.trim() : null;
        
        // save title without number
        if (originalTitle === null) {
            var titleText = '';
            for (var i = 0; i < headElem.childNodes.length; i++) {
                var node = headElem.childNodes[i];
                if (node.nodeType === 3) {
                    titleText += node.textContent;
                }
            }
            originalTitle = titleText.trim();
            
            // set dataset.original before frontend.js
            headElem.dataset.original = originalTitle;
        }
    }, true);
    
    // bubble phase (starts after frontend.js)
    filterElem.addEventListener("category.updated", function (e) {
        var category = e.detail.category;
        var headElem = document.getElementsByTagName('h1')[0];
        
        // use saved title without number
        var newText = originalTitle || headElem.dataset.original;
        if (category) {
            newText += ' - ' + category.name;
        }
        
        // add <small> with count
        if (cachedCount) {
            headElem.innerHTML = newText + '\n\n<small class="is-count">' + cachedCount + '</small>';
        }
    }, false);
}